/**
 * Canonical deployment URLs. Set REACT_APP_* in Vercel before build.
 * Local ports: user API :3001 | stripe :3002 | admin API :3003 | user app :3000 | admin app :5173
 */
export const PRODUCTION = {
  USER_API: "https://toc-user-backend-iota.vercel.app",
  ADMIN_API: "https://adminb-backend-mu.vercel.app",
  STRIPE_API: "https://stripe-backend-sigma-taupe.vercel.app",
  USER_APP: "https://impact-alignment-map.vercel.app",
  ADMIN_APP: "https://qfo-admin-iota.vercel.app",
  ADMIN_APP_PATH: "https://qfo-admin-iota.vercel.app/admin",
} as const;

export const LOCAL = {
  USER_API: "http://localhost:3001",
  ADMIN_API: "http://localhost:3003",
  STRIPE_API: "http://localhost:3002",
  USER_APP: "http://localhost:3000",
  ADMIN_APP: "http://localhost:5173",
  ADMIN_APP_PATH: "http://localhost:5173/admin",
} as const;

export function isDevRuntime(): boolean {
  return process.env.NODE_ENV === "development";
}

export function userApiBase(): string {
  return (
    process.env.REACT_APP_API_BASE?.trim() ||
    (isDevRuntime() ? LOCAL.USER_API : PRODUCTION.USER_API)
  );
}

export function paymentApiBase(): string {
  return (
    process.env.REACT_APP_PAYMENT_API_BASE?.trim() ||
    (isDevRuntime() ? LOCAL.STRIPE_API : PRODUCTION.STRIPE_API)
  );
}

export function adminApiBase(): string {
  return (
    process.env.REACT_APP_ADMIN_API_BASE?.trim() ||
    process.env.REACT_APP_API_BASE?.trim() ||
    (isDevRuntime() ? LOCAL.ADMIN_API : PRODUCTION.ADMIN_API)
  );
}

export function adminAppUrl(): string {
  return (
    process.env.REACT_APP_ADMIN_URL?.trim() ||
    (isDevRuntime() ? LOCAL.ADMIN_APP_PATH : PRODUCTION.ADMIN_APP_PATH)
  );
}

export function frontendOrigin(): string {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return (
    process.env.REACT_APP_FRONTEND_ORIGIN?.trim() ||
    (isDevRuntime() ? LOCAL.USER_APP : PRODUCTION.USER_APP)
  );
}

export function adminProxyTarget(): string {
  return (
    process.env.REACT_APP_ADMIN_PROXY_TARGET?.trim() ||
    (isDevRuntime() ? LOCAL.ADMIN_API : PRODUCTION.ADMIN_API)
  );
}
